// extracted by mini-css-extract-plugin
export default {"loaderWrapper":"PageLoader_loaderWrapper__82KK5","loaderBox":"PageLoader_loaderBox__6j5Ob","loaderBox__dot":"PageLoader_loaderBox__dot__G8MN1","tint":"PageLoader_tint__9Fzad"};